import template from './tsz-user-settings.html';
import './tsz-user-settings.styl';

import changePasswordTpl from './modals/change-password.html';

function controller($tszToast, AuthService, UserService, $mdDialog) {

  'ngInject';

  this.user = AuthService.getAuthenticatedUser();

  this.save = (form) => {
    if (form.$valid) {

      const user = {
        id: this.user.id,
        name: this.user.name,
        phone: this.user.phone,
        email: this.user.email,
      };

      UserService.update(user)
      .then((userData) => {
        AuthService.setCredentials(userData.data);
        $tszToast.showSuccess('Tu perfil ha sido actualizado');
      }).catch(() => {
        $tszToast.showError('Error al guardar tu perfil');
      });
    }
  };

  this.showChangePasswordDialog = (ev) => {

    $mdDialog.show({
      controller: ($scope) => {

        $scope.data = {};

        $scope.changePassword = (form) => {

          if (form.$valid) {
            this.loading = true;
          }

          AuthService.updatePassword($scope.data.currentPassword, $scope.data.newPassword)
          .then(() => {
            $tszToast.showSuccess('Contraseña actualizada');
            $mdDialog.hide();
          }).catch((err) => {
            if (err.data && err.data.code) {
              $tszToast.showErrorI18n(err.data.code, 'Error al intentar actualizar la contaseña');
            } else {
              $tszToast.showError('Error al intentar actualizar la contaseña');
            }
          }).finally(() => {
            this.loading = false;
          });
        };

        $scope.close = () => {
          $mdDialog.hide();
        };

      },
      template: changePasswordTpl,
      targetEvent: ev,
      clickOutsideToClose: false,
      fullscreen: false, // Only for -xs, -sm breakpoints.
    });
  };

}

export default {
  template,
  controller,
};



// WEBPACK FOOTER //
// ./src/components/tsz-user-settings/tsz-user-settings.js